import $ from 'jquery';

// Same as on www.waldorfschule.de: in case we got "radio" buttons, this piece of js allows
// unchecking of an activated radio button. Every other behaviour is done in CSS.
$('.accordion--radio .accordion__header').on('click', function (ev) {
    const $check = $(this).closest('.accordion__element').find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
        ev.preventDefault();
    }
});
